const FAV_KEY = "webtoon_favorites";
const PROGRESS_KEY = "webtoon_progress";
const SETTINGS_KEY = "webtoon_reader_settings";

export interface ReaderSettings {
  fontSize: "sm" | "base" | "lg";
  theme: "light" | "dark" | "green";
}

export const defaultReaderSettings: ReaderSettings = {
  fontSize: "base",
  theme: "light",
};

function readJSON<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function getFavorites(): string[] {
  return readJSON<string[]>(FAV_KEY, []);
}

export function isFavorite(id: string): boolean {
  return getFavorites().includes(id);
}

export function toggleFavorite(id: string): string[] {
  const current = getFavorites();
  const next = current.includes(id)
    ? current.filter((item) => item !== id)
    : [...current, id];
  localStorage.setItem(FAV_KEY, JSON.stringify(next));
  return next;
}

export function getProgress(): Record<string, string> {
  return readJSON<Record<string, string>>(PROGRESS_KEY, {});
}

export function setProgress(comicId: string, chapterId: string): void {
  const current = getProgress();
  current[comicId] = chapterId;
  localStorage.setItem(PROGRESS_KEY, JSON.stringify(current));
}

export function getReaderSettings(): ReaderSettings {
  return readJSON<ReaderSettings>(SETTINGS_KEY, defaultReaderSettings);
}

export function saveReaderSettings(settings: ReaderSettings): void {
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
}